var map = {
	"./icon-armani.svg": 29,
	"./icon-arrow-left.svg": 30,
	"./icon-arrow-right.svg": 31,
	"./icon-close.svg": 32,
	"./icon-facebook.svg": 33,
	"./icon-getty.svg": 34,
	"./icon-google.svg": 35,
	"./icon-harpercollins.svg": 36,
	"./icon-imperial.svg": 37,
	"./icon-instagram.svg": 38,
	"./icon-john-lewis.svg": 39,
	"./icon-linkedin.svg": 40,
	"./icon-mail.svg": 41,
	"./icon-map.svg": 42,
	"./icon-mercedes.svg": 43,
	"./icon-olympics.svg": 44,
	"./icon-oreo.svg": 45,
	"./icon-phone.svg": 46,
	"./icon-playstation.svg": 47,
	"./icon-twitter.svg": 48,
	"./icon-ubisoft.svg": 49,
	"./icon-warner-bros.svg": 50,
	"./icon-zeitgeist.svg": 51,
	"./logo-full.svg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;